import React, { ReactNode } from 'react';
import styles from './SubscriptionCenter.module.scss';
import EmailSubscription, {
  EmailSubscriptionProps,
} from '../MyAccount/EmailSubscription/EmailSubscription';
import CtaLink from 'components/helpers/Atoms/Cta/CtaLink';
import { signOut } from 'next-auth/react';
import CtaButton from 'components/helpers/Atoms/Cta/CtaButton';
import { useEmailSubscription } from 'lib/hooks/useEmailSubscription';

export interface SubscriptionCenterProps {
  heading?: ReactNode;
  topDescription?: ReactNode;
  emailLabel?: ReactNode;
  userEmail?: string;
  noteLink?: ReactNode;
  emailSubscription?: EmailSubscriptionProps;
  unsubscribeConfirmation?: {
    confirmationText?: ReactNode;
    buttonText?: string;
    cancelText?: string;
    unsubscribeSuccessText?: string;
    unsubscribeFailureText?: string;
  };
}

const SubscriptionCenter = (props: SubscriptionCenterProps) => {
  const { heading, topDescription, emailLabel, userEmail, noteLink, emailSubscription } = props;
  const [showUnsubscribeConfirmation, setShowUnsubscribeConfirmation] = React.useState(false);
  const [isUnsubscribeSuccess, setIsUnsubscribeSuccess] = React.useState<boolean | undefined>(
    undefined
  );
  const [disableConfirmBtn, setDisableConfirmBtn] = React.useState(false);
  const handleToggleSubscription = useEmailSubscription(
    emailSubscription?.newsLetterSubscriptionId
  ).handleToggleSubscription;
  const handleUnsubscribeClick = () => {
    setShowUnsubscribeConfirmation(true);
  };
  return (
    <div className={styles.subscriptionCenterContainer}>
      <div className={styles.subscriptionCenterHeader}>
        {showUnsubscribeConfirmation ? (
          <div className={styles.unsubscribeConfirmation}>
            <div className={styles.unsubscribeConfirmationText}>
              {isUnsubscribeSuccess === true
                ? props.unsubscribeConfirmation?.unsubscribeSuccessText ||
                  'You have successfully unsubscribed.'
                : isUnsubscribeSuccess === false
                  ? props.unsubscribeConfirmation?.unsubscribeFailureText ||
                    'There was an error unsubscribing. Please try again.'
                  : props.unsubscribeConfirmation?.confirmationText}
            </div>
            {isUnsubscribeSuccess === undefined && (
              <CtaButton
                text={props.unsubscribeConfirmation?.buttonText}
                ctaStyle="filled"
                type="button"
                disabled={disableConfirmBtn}
                onClick={async () => {
                  setDisableConfirmBtn(true);
                  const { success } = await handleToggleSubscription(true);
                  setDisableConfirmBtn(false);
                  setIsUnsubscribeSuccess(success);
                }}
                ctaComponentClass="component-hero-product-color-cta-1-color"
              />
            )}
            <CtaButton
              ctaComponentClass="component-hero-product-color-cta-1-color"
              ctaStyle="link-invert-underline"
              type="button"
              onClick={() => {
                setShowUnsubscribeConfirmation(false);
                setIsUnsubscribeSuccess(undefined);
              }}
              text={
                isUnsubscribeSuccess !== undefined
                  ? 'Close'
                  : props.unsubscribeConfirmation?.cancelText || 'Cancel'
              }
            />
          </div>
        ) : (
          <>
            <span className={styles.subscriptionCenterTitle}>{heading}</span>
            <span
              className={styles.subscriptionCenterDescription}
              onClick={() => handleUnsubscribeClick()}
            >
              {topDescription}
            </span>
          </>
        )}
        <span className={styles.subscriptionCenterEmail}>
          {emailLabel}
          {userEmail && <span className={styles.subscriptionCenterEmailValue}>{userEmail}</span>}
        </span>
        <CtaLink
          className={styles.subscriptionCenterChangeEmail}
          text={noteLink as string}
          ctaStyle="link"
          ctaComponentClass="component-site-header-color-utility-bar-button-color-1"
          url={'/emailsubscription/unsubscribe'}
          onClick={() => signOut()}
        />
      </div>
      <hr className={styles.divider} />

      {emailSubscription && <EmailSubscription {...emailSubscription} />}
    </div>
  );
};

export default SubscriptionCenter;
